import { ApiPromise } from '@/types';
import { HTTP } from '@/utils';

export default class IntegrationSchoolDayService {
  static url = 'integrations/schoolday';

  static status(tenantId: number): ApiPromise {
    return HTTP.post(`${this.url}/status`, { tenant_id: tenantId });
  }

  static organizations(tenantId: number): ApiPromise {
    return HTTP.post(`${this.url}/organizations`, {
      tenant_id: tenantId,
    });
  }

  static users(tenantId: number | null, organizationId: number): ApiPromise {
    return HTTP.post(`${this.url}/students`, {
      tenant_id: tenantId,
      organization_id: organizationId,
    });
  }

  static organizationStudents(
    tenantId: number | null,
    schoolId: string,
    orderBy: string | null,
    order: string | null,
  ): ApiPromise {
    return HTTP.post(`${this.url}/organizations/${schoolId}/students`, {
      tenant_id: tenantId,
      school_id: schoolId,
      order_by: orderBy,
      order: order,
    });
  }

  static sync(tenantId: number | null, id: number): ApiPromise {
    return HTTP.post(`${this.url}/sync`, {
      tenant_id: tenantId,
      integration_organization_id: id,
    });
  }
}
